import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './redux/reducers/store';
import { BrowserRouter as Router } from 'react-router-dom';
import './tailwind.output.css';
import App from './App';
import * as serviceWorker from './serviceWorker';


const rootElement = document.getElementById('root');

ReactDOM.render(
  <Provider store={configureStore()}>
    <Router>
      <App />
    </Router>
  </Provider>,
  rootElement
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
